module.exports = __webpack_public_path__ + "static/img/my.7bd6cc72.png";